import { JiraIssueFieldOptionAri } from '@atlassian/ari/jira/issue-field-option';
import type { jiraCascadingSelectFieldFragment as JiraCascadingSelectField } from '@atlassian/jira-business-fields/src/common/field-types/cascading-select/fragment/__generated_apollo__/jiraCascadingSelectFieldFragment.ts';
import { CASCADING_SELECT_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { CASCADING_SELECT_GQL_TYPE } from '../constants';
import type { TransformedCascadingSelectField } from '../types';
import type { CascadingSelectTransformersMapping } from './types';

export const transformCascadingSelectField = (): CascadingSelectTransformersMapping => ({
	[CASCADING_SELECT_GQL_TYPE]: (
		field: JiraCascadingSelectField,
	): TransformedCascadingSelectField | null => {
		if (field.__typename !== CASCADING_SELECT_GQL_TYPE) {
			return null;
		}

		return {
			type: CASCADING_SELECT_CF_TYPE,
			id: field.id,
			fieldId: field.fieldId,
			value:
				field.cascadingOption && field.cascadingOption.parentValue
					? {
							parentOptionValue: {
								id: field.cascadingOption.parentValue.id,
								optionId: JiraIssueFieldOptionAri.parse(field.cascadingOption.parentValue.id)
									.optionId,
								value: field.cascadingOption.parentValue.value,
								isDisabled: field.cascadingOption.parentValue.isDisabled,
							},
							...(field.cascadingOption.childOptionValue
								? {
										childOptionValue: {
											id: field.cascadingOption.childOptionValue.id,
											optionId: field.cascadingOption.childOptionValue.optionId,
											value: field.cascadingOption.childOptionValue.value,
											isDisabled: field.cascadingOption.childOptionValue.isDisabled,
										},
									}
								: {}),
						}
					: null,
		};
	},
});
